import { Trans } from "react-i18next";
import {
  InfoContainer,
  PrivacyPolicyContainer,
  PrivacyPolicyContentContainer,
  PrivacyPolicyText,
  PrivacyPolicyTitle,
  UpdateText,
} from "./PrivacyPolicyContent.styled";
import { DefinitionSectionContent } from "./PrivacyPolicyContentSections/DefinitionSection";
import { UsePersonalDataSectionContent } from "./PrivacyPolicyContentSections/UsePersonalDataSection";
import { PersonalDataSectionContent } from "./PrivacyPolicyContentSections/PersonalDataSection";
import { CookiesSectionContent } from "./PrivacyPolicyContentSections/CookiesSection";
import { RetentionPersonalDataSectionContent } from "./PrivacyPolicyContentSections/RetentionPersonalDataSection";
import { TransferPersonalDataSectionContent } from "./PrivacyPolicyContentSections/TransferPersonalDataSection";
import { DisclosurePersonalDataSectionContent } from "./PrivacyPolicyContentSections/DisclosurePersonalDataSection";
import { SecurityPersonalDataSectionContent } from "./PrivacyPolicyContentSections/SecurityPersonalDataSection";
import { ChangesPrivacyPolicySectionContent } from "./PrivacyPolicyContentSections/ChangesPrivacyPolicySection";
import { ContactSectionContent } from "./PrivacyPolicyContentSections/ContactSection";

export const PrivacyPolicyContent = (props: PrivacyPolicyContentProps) => {
  return (
    <PrivacyPolicyContainer>
      <PrivacyPolicyTitle>
        <Trans i18nKey={"privacyPolicy.title"} />
      </PrivacyPolicyTitle>
      <PrivacyPolicyContentContainer>
        <InfoContainer>
          <UpdateText>
            <Trans i18nKey={"privacyPolicy.lastUpdate"} />
          </UpdateText>
          <PrivacyPolicyText>
            <Trans i18nKey={"privacyPolicy.text"} />
          </PrivacyPolicyText>
        </InfoContainer>
        <DefinitionSectionContent />
        <PersonalDataSectionContent />
        <CookiesSectionContent />
        <UsePersonalDataSectionContent />
        <RetentionPersonalDataSectionContent />
        <TransferPersonalDataSectionContent />
        <DisclosurePersonalDataSectionContent />
        <SecurityPersonalDataSectionContent />
        <ChangesPrivacyPolicySectionContent />
        <ContactSectionContent />
      </PrivacyPolicyContentContainer>
    </PrivacyPolicyContainer>
  );
};

export interface PrivacyPolicyContentProps {}
